import { MapGeometry, MapPositionPercent, positionPercent } from '@/app/location/locationGeometry';

export interface HouseLocation {
  lat: number;
  lng: number;
}

interface HouseCoordinates {
  house_latitude?: number | null;
  house_longitude?: number | null;
}

const isLatitude = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= 90;

const isLongitude = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= 180;

export const houseLocationOf = (
  { house_latitude: latitude, house_longitude: longitude }: HouseCoordinates,
): HouseLocation | null => {
  if (isLatitude(latitude) && isLongitude(longitude)) {
    return { lat: latitude, lng: longitude };
  }

  return null;
};

const isOnTheImage = ({ left, top }: MapPositionPercent): boolean =>
  left >= 0 && left <= 100 && top >= 0 && top <= 100;

export const housePinPosition = (
  house: HouseLocation | null,
  geometry: MapGeometry | null,
): MapPositionPercent | null => {
  if (!house || !geometry) {
    return null;
  }
  const position = positionPercent(house, geometry);

  if (!isOnTheImage(position)) {
    return null;
  }

  return position;
};
